import { pointerIntersection } from "@dnd-kit/collision";
import { useDragOperation, useDroppable } from "@dnd-kit/react";

import {
  FOLDER_MOVE_DROP_TYPE,
  ITEM_MOVE_DRAG_TYPE,
  isItemMoveDragData,
  type FolderMoveDropData,
} from "../item-move-dnd";

interface UseFolderMoveDropTargetOptions {
  folderId: string;
  folderName: string;
  disabled?: boolean;
}

export function useFolderMoveDropTarget({
  folderId,
  folderName,
  disabled = false,
}: UseFolderMoveDropTargetOptions) {
  const { source } = useDragOperation();
  const isDropAvailable = Boolean(
    !disabled &&
    source?.type === ITEM_MOVE_DRAG_TYPE &&
    isItemMoveDragData(source.data) &&
    source.data.items.some((item) => (item.folder_id || "0") !== folderId),
  );
  const droppable = useDroppable<FolderMoveDropData>({
    id: `${FOLDER_MOVE_DROP_TYPE}:${folderId}`,
    type: FOLDER_MOVE_DROP_TYPE,
    collisionDetector: pointerIntersection,
    disabled,
    data: {
      kind: FOLDER_MOVE_DROP_TYPE,
      folderId,
      folderName,
    },
    accept: (source) => {
      if (source.type !== ITEM_MOVE_DRAG_TYPE || !isItemMoveDragData(source.data)) {
        return false;
      }

      return source.data.items.some((item) => (item.folder_id || "0") !== folderId);
    },
  });

  return {
    ...droppable,
    isDropAvailable,
  };
}
